export default [
  {
    id: "CRE",
    color: '',
    summary: 'Documento recibido',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "APR",
    color: '',
    summary: 'Documento aprobado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "OBS",
    color: '',
    summary: 'Documento aprobado con observaciones',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "DUP",
    color: '',
    summary: 'Documento duplicado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "REJ",
    color: '',
    summary: 'Documento rechazado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RAP",
    color: '',
    summary: 'Documento aprobado por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROB",
    color: '',
    summary: 'Documento aprobado con discrepancias por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RRJ",
    color: '',
    summary: 'Documento rechazado por el receptor',
    icon: 'mdi-calendar-blank'
  }
]